/** CSS declaration extraction/mutation backed by css-tree, never regex. */

import * as csstree from '../vendor/csstree.esm.js';

function parseStylesheet(cssText) {
  try {
    return csstree.parse(String(cssText || ''), { parseCustomProperty: true });
  } catch {
    return null;
  }
}

function parseDeclarationList(styleText) {
  try {
    return csstree.parse(String(styleText || ''), {
      context: 'declarationList',
      parseCustomProperty: true
    });
  } catch {
    return null;
  }
}

function declarationValue(node) {
  return node?.value ? csstree.generate(node.value).trim() : '';
}

export function collectStylesheetPaintValues(cssText, processValue) {
  const ast = parseStylesheet(cssText);
  if (!ast || typeof processValue !== 'function') return false;
  csstree.walk(ast, {
    visit: 'Declaration',
    enter(node) {
      const property = String(node.property || '').toLowerCase();
      if (property === 'fill' || property === 'stroke') processValue(declarationValue(node));
    }
  });
  return true;
}

export function collectInlineCustomProperties(styleText, vars) {
  const ast = parseDeclarationList(styleText);
  if (!ast || !vars) return false;
  csstree.walk(ast, {
    visit: 'Declaration',
    enter(node) {
      const property = String(node.property || '');
      if (property.startsWith('--')) vars[property] = declarationValue(node);
    }
  });
  return true;
}

export function collectStylesheetCustomProperties(
  cssText,
  vars,
  { excludeSelector = (selector) => selector.includes('.dark-mode') } = {}
) {
  const ast = parseStylesheet(cssText);
  if (!ast || !vars) return false;
  csstree.walk(ast, {
    visit: 'Rule',
    enter(rule) {
      const selector = rule.prelude ? csstree.generate(rule.prelude).trim() : '';
      if (excludeSelector(selector)) return;
      csstree.walk(rule.block, {
        visit: 'Declaration',
        enter(declaration) {
          const property = String(declaration.property || '');
          if (property.startsWith('--')) vars[property] = declarationValue(declaration);
        }
      });
    }
  });
  return true;
}

export function replaceStylesheetPaintValues(cssText, shouldReplace, newValue) {
  const ast = parseStylesheet(cssText);
  if (!ast || typeof shouldReplace !== 'function')
    return { css: String(cssText || ''), changed: false };
  let changed = false;
  let replacement;
  try {
    replacement = csstree.parse(String(newValue || ''), {
      context: 'value',
      parseCustomProperty: true
    });
  } catch {
    return { css: String(cssText || ''), changed: false };
  }
  csstree.walk(ast, {
    visit: 'Declaration',
    enter(node) {
      const property = String(node.property || '').toLowerCase();
      if ((property === 'fill' || property === 'stroke') && shouldReplace(declarationValue(node))) {
        node.value = csstree.clone(replacement);
        changed = true;
      }
    }
  });
  return { css: changed ? csstree.generate(ast) : String(cssText || ''), changed };
}
